import React, { forwardRef } from "react";
import { User } from "@supabase/supabase-js";
import EnhancedAvatarUpload, { EnhancedAvatarUploadRef } from "../enhanced-avatar";

interface AvatarSectionProps {
  user: User;
  avatarUrl: string | null;
  isUploading: boolean;
  onAvatarChange: (avatarUrl: string) => void;
}

const AvatarSection = forwardRef<EnhancedAvatarUploadRef, AvatarSectionProps>(({
  user,
  avatarUrl,
  isUploading,
  onAvatarChange,
}, ref) => {
  return (
    <div>
      <label className="text-sm font-medium block mb-2">Profile Picture</label>
      <EnhancedAvatarUpload
        ref={ref}
        user={user}
        avatarPreview={avatarUrl}
        onAvatarChange={onAvatarChange}
        isUploading={isUploading}
      />
    </div>
  );
});

AvatarSection.displayName = "AvatarSection";

export default AvatarSection;
